var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _g, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSomethingWentWrong(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 328,
    height: 276,
    viewBox: "0 0 328 276",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.29 275.5C240.066 275.5 301.495 213.939 301.495 138C301.495 62.0609 240.066 0.5 164.29 0.5C88.5145 0.5 27.0859 62.0609 27.0859 138C27.0859 213.939 88.5145 275.5 164.29 275.5Z",
    fill: "#F7F8F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.068 195.649L266.508 196.001L265.572 190.545L269.905 190.493L270.068 195.649Z",
    fill: "#F0AE8D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.347 193.06C270.347 193.06 273.136 196.855 270.684 199.681L255.326 199.73C255.326 199.73 254.912 196.525 260.235 195.875L265.549 192.847C265.549 192.847 266.272 191.876 266.239 194.412C266.218 196.093 269.881 195.633 269.893 193.942C269.9 193.037 269.89 192.745 270.347 193.06Z",
    fill: "#53565A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.684 199.681L260.457 199.714C260.457 199.714 261.713 197.191 260.234 195.875C260.234 195.875 255.222 196.085 255.251 199.695C255.251 199.695 254.764 200.013 255.267 200.645L271.952 200.592C271.952 200.592 272.715 197.491 271.621 196.191C271.621 196.191 270.254 197.111 270.684 199.681Z",
    fill: "#C2CFD4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M265.07 195.33C264.892 195.406 264.685 195.324 264.609 195.146L264.007 193.756C263.93 193.578 264.013 193.37 264.19 193.293C264.368 193.216 264.576 193.299 264.653 193.476L265.253 194.866C265.33 195.044 265.248 195.253 265.07 195.33Z",
    fill: "#FFFFFE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M264.193 195.825C264.016 195.903 263.807 195.819 263.731 195.642L263.13 194.253C263.054 194.075 263.136 193.866 263.313 193.789C263.491 193.712 263.699 193.794 263.776 193.972L264.376 195.362C264.453 195.54 264.371 195.748 264.193 195.825Z",
    fill: "#FFFFFE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M263.246 196.339C263.068 196.416 262.86 196.334 262.783 196.156L262.183 194.766C262.106 194.588 262.188 194.38 262.366 194.303C262.544 194.225 262.752 194.309 262.829 194.486L263.429 195.875C263.506 196.053 263.424 196.262 263.246 196.339Z",
    fill: "#FFFFFE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M276.409 105.008L256.461 154.558L265.187 190.834L270.167 190.739L268.882 155.732L284.421 127.733L276.409 105.008Z",
    fill: "#C2CFD4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.167 190.739L268.882 155.732L283.358 132.072L280.586 122.693L263.938 155.133L269.12 190.738L270.167 190.739Z",
    fill: "#9EA6AC"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M293.105 195.958L289.183 196.017L288.732 188.181L293.462 188.073L293.105 195.958Z",
    fill: "#F0AE8D"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M293.661 193.077C293.661 193.077 296.459 196.915 293.975 199.755L278.485 199.743C278.485 199.743 278.081 196.511 283.451 195.875L288.824 192.842C288.824 192.842 289.555 191.865 289.513 194.423C289.485 196.12 293.181 195.67 293.199 193.964C293.21 193.052 293.201 192.757 293.661 193.077Z",
    fill: "#53565A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M293.977 199.755L283.662 199.747C283.662 199.747 284.94 197.208 283.453 195.875C283.453 195.875 278.396 196.067 278.412 199.708C278.412 199.708 277.92 200.028 278.425 200.667L295.252 200.68C295.252 200.68 296.034 197.555 294.937 196.239C294.937 196.239 293.553 197.162 293.977 199.755Z",
    fill: "#C2CFD4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M288.333 195.344C288.153 195.421 287.944 195.337 287.867 195.158L287.267 193.753C287.19 193.574 287.274 193.365 287.453 193.288C287.633 193.211 287.842 193.294 287.919 193.474L288.519 194.878C288.596 195.058 288.512 195.267 288.333 195.344Z",
    fill: "#FFFFFE"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M287.446 195.841C287.266 195.917 287.057 195.834 286.98 195.654L286.38 194.251C286.303 194.07 286.387 193.861 286.566 193.784C286.746 193.707 286.955 193.791 287.032 193.97L287.632 195.375C287.709 195.554 287.625 195.764 287.446 195.841Z",
    fill: "#FFFFFE"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M286.489 196.356C286.31 196.433 286.1 196.348 286.023 196.168L285.423 194.765C285.346 194.585 285.43 194.375 285.61 194.298C285.789 194.221 285.998 194.305 286.075 194.485L286.675 195.889C286.752 196.068 286.668 196.279 286.489 196.356Z",
    fill: "#FFFFFE"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M282.179 137.224L279.105 112.637L295.352 110.158C295.352 110.158 300.776 120.157 293.99 190.685L288.453 190.325C286.776 183.343 283.839 154.457 282.179 137.224Z",
    fill: "#C2CFD4"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M272.197 77.56L262.506 97.0829L250.635 90.3217L246.035 93.4826L260.377 103.732C260.377 103.732 262.716 106.364 265.486 104.546C268.255 102.727 276.827 86.7467 276.827 86.7467L272.197 77.56Z",
    fill: "#E19B7C"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M287.334 69.8431C287.334 69.8431 302.575 70.9084 300.166 81.8494C297.755 92.7904 294.562 98.4126 296.83 114.753C296.83 114.753 287.829 119.012 272.517 113.897C272.517 113.897 269.115 87.6749 272.093 77.3019C272.093 77.3019 274.042 69.31 287.334 69.8431Z",
    fill: "#0099FF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M289.351 63.4128L289.791 71.6312C289.791 71.6312 284.994 74.1978 282.275 71.8451L282.875 64.5518L289.351 63.4128Z",
    fill: "#E19B7C"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M282.663 67.2101L282.557 69.0171C282.557 69.0171 289.18 66.6306 289.18 64.0386L283.826 65.5032L282.663 67.2101Z",
    fill: "#D6896A"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M289.805 64.4749L289.688 64.4622C288.902 64.38 288.328 63.6688 288.41 62.8828L288.923 57.9855C289.005 57.1995 289.715 56.6231 290.499 56.7043L290.618 56.7169C291.402 56.7991 291.977 57.5092 291.895 58.2953L291.381 63.1947C291.299 63.9817 290.59 64.557 289.805 64.4749Z",
    fill: "#252529"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M281.648 67.4472C282.993 67.4999 286.713 66.1101 287.761 65.6117C287.761 65.6117 289.815 64.9184 289.862 61.276C289.862 61.276 290.313 61.5605 290.709 60.6185L290.744 60.4499L291.418 58.2057C291.904 55.6106 290.39 53.1282 288.055 52.6888L286.177 52.3369C285.649 51.6816 285.001 51.2401 284.25 51.0989C282.909 50.8471 281.522 51.5899 280.384 52.9723C280.321 53.0439 280.53 52.2463 279.836 52.3654C278.286 52.633 277.691 55.4504 277.656 57.8864C277.599 61.9229 279.098 66.9657 281.139 67.3871L281.648 67.4472Z",
    fill: "#E19B7C"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M291.049 59.9337C290.736 61.0389 290.002 61.7986 289.408 61.6311C288.814 61.4625 288.585 60.4299 288.897 59.3247C289.209 58.2183 289.944 57.4587 290.538 57.6272C291.132 57.7958 291.36 58.8284 291.049 59.9337Z",
    fill: "#F0AE8D"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M283.105 54.2862C283.105 54.2862 274.928 59.8357 276.895 53.615C276.895 53.615 269.147 46.2975 287.835 50.0263C287.835 50.0263 297.055 48.2857 291.487 59.9263L291.082 59.9421C291.082 59.9421 291.487 57.6462 290.289 57.7368C290.289 57.7368 289.481 57.7063 288.792 59.6871C288.792 59.6871 289.511 51.3465 283.105 54.2862Z",
    fill: "#252529"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M297.986 74.0345C297.986 74.0345 307.968 85.2684 309.196 99.7328L293.61 122.194L290.498 120.059L302.15 99.3261C302.15 99.3261 300.596 88.8076 295.53 84.9608L297.986 74.0345Z",
    fill: "#E19B7C"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M280.105 71.9146C280.105 73.2011 282.628 74.2431 285.738 74.2431C288.848 74.2431 291.369 73.2011 291.369 71.9146C291.369 70.6292 288.848 69.5871 285.738 69.5871C282.628 69.5871 280.105 70.6292 280.105 71.9146Z",
    fill: "#E19B7C"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M296.314 72.6732C296.314 72.6732 302.239 74.5951 306.416 85.2737C306.416 85.2737 303.816 89.503 299.682 92.194L294.396 83.3951C294.396 83.3951 294.737 73.6552 296.314 72.6732Z",
    fill: "#0099FF"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M273.168 75.2999L267.713 83.9071C267.713 83.9071 269.078 87.6665 271.209 90.485L275.129 76.7308L273.168 75.2999Z",
    fill: "#0099FF"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M274.465 73.0683C274.465 73.0683 272.365 79.0709 272.869 83.7175L275.378 83.7396C275.378 83.7396 276.679 73.1558 278.627 70.8736L274.465 73.0683Z",
    fill: "#C2CFD4"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M292.228 70.6323C292.228 70.6323 288.9 80.0772 289.403 84.7248L292.287 84.8807C292.287 84.8807 293.588 74.2969 295.536 72.0147L292.228 70.6323Z",
    fill: "#C2CFD4"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M271.617 82.6828C271.617 82.6828 268.287 107.443 272.844 115.17L291.068 118.156L292.295 116.268C292.295 116.268 288.264 97.4338 294.046 84.6141C294.046 84.6141 283.358 79.8727 271.617 82.6828Z",
    fill: "#C2CFD4"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M288.594 86.675L274.48 85.9259L274.546 84.6984L288.659 85.4475L288.594 86.675Z",
    fill: "#9EA6AC"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M289.316 118.946L295.8 123.687L295.187 124.828L288.002 119.297L289.316 118.946Z",
    fill: "#9EA6AC"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M247.04 87.0818C247.04 87.0818 244.47 78.227 241.747 78.0752C239.024 77.9235 243.78 81.5069 243.327 83.629V91.7167L252.059 98.9752L254.972 91.6387L247.04 87.0818Z",
    fill: "#0099FF"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M238.124 83.4962L241.256 84.6236C241.726 84.7922 242.249 84.5456 242.417 84.0747C242.586 83.6037 242.339 83.0811 241.869 82.9114L238.738 81.7841C238.268 81.6155 237.746 81.862 237.576 82.333C237.408 82.804 237.654 83.3276 238.124 83.4962Z",
    fill: "#0099FF"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M238.427 85.3917L241.559 86.5181C242.028 86.6877 242.55 86.4411 242.72 85.9702C242.888 85.4992 242.642 84.9755 242.172 84.8059L239.04 83.6795C238.57 83.5099 238.048 83.7575 237.879 84.2274C237.711 84.6984 237.957 85.2221 238.427 85.3917Z",
    fill: "#0099FF"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M238.634 87.3789L241.766 88.5063C242.236 88.6749 242.758 88.4283 242.927 87.9573C243.095 87.4863 242.849 86.9627 242.379 86.7941L239.248 85.6667C238.778 85.4981 238.255 85.7447 238.086 86.2157C237.918 86.6866 238.164 87.2092 238.634 87.3789Z",
    fill: "#0099FF"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M239.013 89.425L242.145 90.5524C242.614 90.721 243.137 90.4745 243.306 90.0035C243.474 89.5325 243.228 89.0089 242.758 88.8403L239.626 87.7129C239.156 87.5443 238.634 87.7909 238.465 88.2618C238.296 88.7328 238.543 89.2565 239.013 89.425Z",
    fill: "#0099FF"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M227.031 72.3032L227.78 71.2695L219.185 65.0107L212.571 74.1351L208.102 70.8811L218.773 56.1613L217.741 55.4103L206.322 71.1631L212.854 75.9194L219.468 66.7959L227.031 72.3032Z",
    fill: "#858585"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.033 70.6493L220.77 57.2185C221.181 56.6508 221.054 55.8471 220.486 55.4338L218.295 53.8382C217.727 53.4249 216.926 53.5525 216.515 54.1202L206.778 67.551C206.366 68.1195 206.493 68.9217 207.061 69.335L209.252 70.9306C209.82 71.344 210.621 71.2178 211.033 70.6493Z",
    fill: "#252529"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M321.64 142.486L323.518 139.896L223.841 67.3191L221.963 69.9096L321.64 142.486Z",
    fill: "#1C212F"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M238.124 83.4963L241.256 84.6237C241.726 84.7923 242.249 84.5458 242.417 84.0748C242.586 83.6038 242.339 83.0812 241.869 82.9116L238.738 81.7842C238.268 81.6156 237.746 81.8621 237.576 82.3331C237.408 82.8041 237.654 83.3278 238.124 83.4963Z",
    fill: "#0099FF"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M238.427 85.3918L241.559 86.5182C242.028 86.6878 242.55 86.4413 242.72 85.9703C242.888 85.4993 242.642 84.9756 242.172 84.806L239.04 83.6797C238.57 83.51 238.048 83.7576 237.879 84.2276C237.711 84.6985 237.957 85.2222 238.427 85.3918Z",
    fill: "#0099FF"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M238.634 87.379L241.766 88.5064C242.236 88.675 242.758 88.4284 242.927 87.9574C243.095 87.4865 242.849 86.9628 242.379 86.7942L239.248 85.6668C238.778 85.4983 238.255 85.7448 238.086 86.2158C237.918 86.6868 238.164 87.2094 238.634 87.379Z",
    fill: "#0099FF"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M239.013 89.4252L242.145 90.5526C242.614 90.7211 243.137 90.4746 243.306 90.0036C243.474 89.5326 243.228 89.009 242.758 88.8404L239.626 87.713C239.156 87.5444 238.634 87.791 238.465 88.2619C238.296 88.7329 238.543 89.2566 239.013 89.4252Z",
    fill: "#0099FF"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.952 163.916V200.692H95.6836V75.4095H140.105L156.61 129.253C159.419 138.754 162.287 149.136 165.213 160.397C168.022 149.253 170.832 138.696 173.641 128.725L189.97 75.4095H234.391V200.692H206.123V163.916C206.123 140.69 206.474 120.513 207.177 103.387C204.836 111.95 202.026 121.452 198.749 131.892L177.153 200.692H152.923L131.326 131.892C127.698 120.044 124.947 110.601 123.074 103.563C123.659 121.393 123.952 141.511 123.952 163.916ZM279.515 171.658V200.692H249.843V171.658H279.515Z",
    fill: "#858585"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.952 163.916V200.692H95.6836V75.4095H140.105L156.61 129.253C159.419 138.754 162.287 149.136 165.213 160.397C168.022 149.253 170.832 138.696 173.641 128.725L189.97 75.4095H234.391V200.692H206.123V163.916C206.123 140.69 206.474 120.513 207.177 103.387C204.836 111.95 202.026 121.452 198.749 131.892L177.153 200.692H152.923L131.326 131.892C127.698 120.044 124.947 110.601 123.074 103.563C123.659 121.393 123.952 141.511 123.952 163.916ZM279.515 171.658V200.692H249.843V171.658H279.515Z",
    fill: "#C2CFD4"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5916_7166",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 95,
    y: 75,
    width: 185,
    height: 126
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.952 163.916V200.692H95.6836V75.4095H140.105L156.61 129.253C159.419 138.754 162.287 149.136 165.213 160.397C168.022 149.253 170.832 138.696 173.641 128.725L189.97 75.4095H234.391V200.692H206.123V163.916C206.123 140.69 206.474 120.513 207.177 103.387C204.836 111.95 202.026 121.452 198.749 131.892L177.153 200.692H152.923L131.326 131.892C127.698 120.044 124.947 110.601 123.074 103.563C123.659 121.393 123.952 141.511 123.952 163.916ZM279.515 171.658V200.692H249.843V171.658H279.515Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5916_7166)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.5892 121.36C59.5892 121.36 52.3625 160.35 71.8566 155.385C91.3507 150.421 106.973 123.633 123.437 139.921C139.901 156.208 142.853 158.246 148.143 151.872C153.434 145.499 155.705 130.552 168.533 130.552C181.361 130.552 187.944 136.946 193.131 136.946C198.318 136.946 201.126 112.713 214.323 124.829C227.519 136.946 242.209 143.341 244.457 136.946C244.997 135.412 244.151 217.814 244.804 208.713C245.374 200.772 271.722 250.856 289.909 192.19C296.43 171.154 295.901 35.9132 295.901 35.9132L74.1344 31.8692L59.5892 121.36Z",
    fill: "#53565A"
  }))), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.1364 196.831L54.2895 196.71L54.463 192.19L50.6602 192.308L51.1364 196.831Z",
    fill: "#F0AE8D"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.4255 196.822L78.5775 196.7L78.752 192.18L74.9492 192.298L75.4255 196.822Z",
    fill: "#F0AE8D"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.7509 193.873L64.8998 127.456C68.0718 117.255 66.6472 109.613 66.6472 109.613L53.4588 109.507C49.8031 114.396 50.8903 119.481 50.8303 124.258C51.1363 139.921 49.8042 185.197 50.1869 193.897L54.7509 193.873Z",
    fill: "#C2CFD4"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.5322 194.522C50.5322 194.522 48.0583 197.858 50.2084 200.359L63.7522 200.464C63.7522 200.464 64.1307 197.641 59.4394 197.045L54.764 194.353C54.764 194.353 54.1321 193.493 54.1489 195.73C54.1615 197.214 50.9328 196.792 50.9296 195.301C50.9275 194.503 50.937 194.246 50.5322 194.522Z",
    fill: "#53565A"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.2071 200.359L59.2258 200.43C59.2258 200.43 58.1271 198.2 59.4381 197.045C59.4381 197.045 63.8571 197.25 63.8171 200.434C63.8171 200.434 64.245 200.716 63.7992 201.272L49.0853 201.159C49.0853 201.159 48.4239 198.419 49.3944 197.278C49.3944 197.278 50.5961 198.095 50.2071 200.359Z",
    fill: "#C2CFD4"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.176 196.545C55.3316 196.613 55.5155 196.542 55.5839 196.385L56.119 195.161C56.1874 195.005 56.1159 194.821 55.9603 194.753C55.8036 194.684 55.6196 194.756 55.5513 194.912L55.0161 196.135C54.9478 196.292 55.0193 196.476 55.176 196.545Z",
    fill: "#FFFFFE"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.9474 196.985C56.103 197.054 56.287 196.982 56.3554 196.825L56.8905 195.603C56.9589 195.446 56.8874 195.261 56.7318 195.193C56.5751 195.124 56.3911 195.196 56.3228 195.353L55.7876 196.576C55.7193 196.732 55.7908 196.917 55.9474 196.985Z",
    fill: "#FFFFFE"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.7804 197.442C56.937 197.511 57.121 197.439 57.1894 197.282L57.7245 196.059C57.7929 195.903 57.7214 195.719 57.5647 195.65C57.4091 195.582 57.2251 195.653 57.1568 195.809L56.6216 197.033C56.5533 197.19 56.6248 197.374 56.7804 197.442Z",
    fill: "#FFFFFE"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.9404 194.522C74.9404 194.522 72.4665 197.858 74.6166 200.359L88.1604 200.464C88.1604 200.464 88.5389 197.641 83.8476 197.045L79.1722 194.353C79.1722 194.353 78.5403 193.493 78.5582 195.73C78.5697 197.214 75.341 196.792 75.3378 195.301C75.3357 194.503 75.3452 194.246 74.9404 194.522Z",
    fill: "#53565A"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.6153 200.359L83.634 200.43C83.634 200.43 82.5353 198.2 83.8463 197.045C83.8463 197.045 88.2653 197.25 88.2253 200.434C88.2253 200.434 88.6532 200.716 88.2074 201.272L73.4935 201.159C73.4935 201.159 72.8321 198.419 73.8026 197.278C73.8026 197.278 75.0043 198.095 74.6153 200.359Z",
    fill: "#C2CFD4"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.5842 196.545C79.7398 196.613 79.9237 196.542 79.9921 196.385L80.5272 195.161C80.5966 195.005 80.5241 194.821 80.3685 194.753C80.2118 194.684 80.0289 194.756 79.9595 194.912L79.4243 196.135C79.356 196.292 79.4275 196.476 79.5842 196.545Z",
    fill: "#FFFFFE"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.3556 196.985C80.5112 197.054 80.6952 196.982 80.7636 196.825L81.2987 195.603C81.3671 195.446 81.2956 195.261 81.14 195.193C80.9833 195.124 80.7993 195.196 80.731 195.353L80.1958 196.576C80.1275 196.732 80.199 196.917 80.3556 196.985Z",
    fill: "#FFFFFE"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.1886 197.442C81.3452 197.511 81.5292 197.439 81.5976 197.282L82.1327 196.059C82.2011 195.903 82.1296 195.719 81.9729 195.65C81.8173 195.582 81.6333 195.653 81.565 195.809L81.0298 197.033C80.9615 197.19 81.033 197.374 81.1886 197.442Z",
    fill: "#FFFFFE"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.8422 111L82.1517 151.916L79.3046 193.096H74.135L72.6452 153.496L59.9414 123.731L65.6367 110.649L69.8422 111Z",
    fill: "#C2CFD4"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.3618 90.3547L78.1538 99.7743L88.8431 90.242L91.7996 91.6244L80.6677 104.265C80.6677 104.265 78.8824 106.272 76.7692 104.885C74.6569 103.498 68.8281 97.3646 68.8281 97.3646L72.3618 90.3547Z",
    fill: "#E19B7C"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.5676 78.5266C55.5676 78.5266 45.0759 80.4979 51.4872 91.8151C57.5211 102.466 54.8012 105.331 52.834 109.603C51.5671 112.353 70.7074 117.405 70.7074 109.734C70.7074 104.861 69.5246 104.73 72.0342 95.6124C73.6344 89.7963 71.804 88.0568 70.1155 85.3689C68.9053 83.4418 68.3408 80.7329 67.2242 79.9026C67.2242 79.9026 64.2383 77.4856 55.5676 78.5266Z",
    fill: "#1393F6"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.8486 70.8318L57.4922 79.4506C57.4922 79.4506 63.4367 82.4883 63.6743 79.5697L62.9015 70.6928L57.8486 70.8318Z",
    fill: "#E19B7C"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.1845 73.6672L63.3307 75.569C63.3307 75.569 57.6953 73.3142 57.6953 70.6506L61.9902 71.9118L63.1845 73.6672Z",
    fill: "#D6896A"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.2198 74.2878C63.8846 74.3405 60.1911 72.9592 59.1513 72.4661C59.1513 72.4661 57.1116 71.777 57.0643 68.1609C57.0643 68.1609 56.6164 68.4433 56.2243 67.5087L56.1896 67.3401L55.5199 65.1116C55.0373 62.5355 56.5407 60.071 58.859 59.6359L60.7231 59.285C61.2467 58.6349 61.8912 58.1966 62.6366 58.0565C63.9687 57.8068 65.345 58.5443 66.4752 59.9161C66.5372 59.9867 66.3301 59.1955 67.0177 59.3145C68.558 59.579 69.1488 62.3774 69.1835 64.7956C69.2403 68.8025 67.7516 73.8094 65.7256 74.2277L65.2198 74.2878Z",
    fill: "#E19B7C"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.7892 67.8817C56.0983 68.9796 56.828 69.734 57.4178 69.5664C58.0076 69.3989 58.2347 68.3737 57.9245 67.2769C57.6154 66.179 56.8858 65.4246 56.296 65.5921C55.7061 65.7586 55.479 66.7838 55.7892 67.8817Z",
    fill: "#F0AE8D"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.3029 81.3082C66.3029 83.0172 65.8004 84.447 62.9522 84.447C60.103 84.447 56.2497 82.9318 55.9868 81.3082C55.7135 79.6203 55.3297 78.0261 61.1449 78.2126C63.992 78.3043 66.3029 79.5981 66.3029 81.3082Z",
    fill: "#E19B7C"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.0979 61.662C59.0979 61.662 70.3129 66.0515 71.0131 63.0665C71.7144 60.0816 73.9927 51.6524 59.6236 57.7983C59.6236 57.7983 54.5423 55.5151 53.6654 60.7833C52.7896 66.0515 54.6075 71.8033 57.6964 75.0296L57.8278 71.0784L57.4178 69.5664C57.4178 69.5664 55.2646 67.5224 56.7764 66.6004C58.2873 65.6785 58.057 68.2799 58.057 68.2799C58.057 68.2799 57.6627 69.9268 59.0106 67.7858C60.3574 65.6458 59.0979 61.662 59.0979 61.662Z",
    fill: "#30373D"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.9083 57.9743C56.9083 57.9743 37.195 43.925 47.8833 80.1007C47.8833 80.1007 52.0015 63.2425 56.9083 57.9743Z",
    fill: "#30373D"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.1343 193.096L72.6445 153.496L63.9707 133.214L65.4163 121.36L66.3363 128.824L67.7388 125.4L76.6755 152.619L76.2592 193.074L74.1343 193.096Z",
    fill: "#9EA6AC"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.5664 86.1497C91.5664 86.1497 93.7217 78.7236 96.0053 78.5961C98.2889 78.4686 94.3 81.4747 94.6806 83.2543V90.0365L89.409 96.3942L85.3496 91.3093L91.5664 86.1497Z",
    fill: "#0099FF"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.5695 89.9712C56.5695 89.9712 68.7917 86.942 72.9972 88.8733C72.9972 88.8733 73.7858 92.8687 71.8145 98.2686C69.8431 103.669 71.4202 108.542 71.4202 108.542C71.4202 108.542 72.8658 112.361 69.186 113.942L61.9578 114.995L55.3867 113.415C55.3867 113.415 61.7381 102.044 56.5695 89.9712Z",
    fill: "#C2CFD4"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.9358 79.2367C67.9358 79.2367 71.8564 85.1856 72.2948 89.8395L69.842 90.3663C69.842 90.3663 66.6879 80.4221 64.3223 78.5782L67.9358 79.2367Z",
    fill: "#C2CFD4"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.8867 92.3851L43.9082 104.502L55.1232 120.658L57.7517 118.551L49.7349 104.064L52.1436 93.7907L46.8867 92.3851Z",
    fill: "#E19B7C"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.5976 79.4085C53.5976 79.4085 47.9381 79.9174 45.748 92.5611C45.748 92.5611 50.0408 95.0192 52.8448 95.6345L53.9372 91.0796L54.9644 86.0022C54.9644 86.0022 54.6353 81.03 53.5976 79.4085Z",
    fill: "#1393F6"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.9126 78.2495C55.9126 78.2495 60.3809 85.7999 60.8183 90.4538L58.3654 90.9806C58.3654 90.9806 55.2113 81.147 52.8457 79.3031L55.9126 78.2495Z",
    fill: "#C2CFD4"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.2401 117.058L53.1074 122.326L53.7204 123.029L60.9927 117.409L59.2401 117.058Z",
    fill: "#9EA6AC"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.2572 93.1058L62.1966 94.2026L62.041 92.7623L72.1006 91.6655L72.2572 93.1058Z",
    fill: "#9EA6AC"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.0431 83.1426L96.4168 84.0877C96.0225 84.2299 95.5841 84.0224 95.4432 83.6283C95.3013 83.2332 95.5084 82.7938 95.9026 82.6526L98.529 81.7075C98.9232 81.5653 99.3606 81.7718 99.5026 82.1669C99.6434 82.562 99.4374 83.0014 99.0431 83.1426Z",
    fill: "#0099FF"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.7892 84.7315L96.1629 85.6776C95.7686 85.8188 95.3302 85.6123 95.1893 85.2172C95.0474 84.8221 95.2545 84.3827 95.6477 84.2415L98.2751 83.2964C98.6683 83.1542 99.1067 83.3617 99.2487 83.7558C99.3895 84.1509 99.1835 84.5903 98.7892 84.7315Z",
    fill: "#0099FF"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.616 86.3983L95.9886 87.3434C95.5943 87.4857 95.157 87.2792 95.015 86.8841C94.8742 86.4889 95.0802 86.0496 95.4745 85.9084L98.1008 84.9633C98.4951 84.821 98.9335 85.0286 99.0744 85.4227C99.2163 85.8178 99.0092 86.2571 98.616 86.3983Z",
    fill: "#0099FF"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.2991 88.1147L95.6727 89.0598C95.2785 89.2021 94.8401 88.9945 94.6992 88.6004C94.5572 88.2053 94.7633 87.766 95.1576 87.6248L97.785 86.6796C98.1782 86.5374 98.6166 86.7439 98.7585 87.139C98.8994 87.5342 98.6933 87.9735 98.2991 88.1147Z",
    fill: "#0099FF"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.0108 87.264L93.1582 86.3151L101.052 79.1921L108.584 87.5749L112.688 83.8716L100.537 70.3481L101.484 69.4935L114.487 83.9659L108.488 89.3791L100.957 80.9963L94.0108 87.264Z",
    fill: "#858585"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.749 83.9447L98.6641 71.6074C98.1948 71.0852 98.2381 70.2734 98.7594 69.8031L100.772 67.9873C101.293 67.517 102.102 67.5594 102.571 68.0817L113.656 80.4189C114.125 80.9412 114.083 81.753 113.562 82.2233L111.55 84.0391C111.029 84.5094 110.218 84.4669 109.749 83.9447Z",
    fill: "black"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.10142 164.595L7.24031 166.975L98.801 84.3562L96.6621 81.9756L5.10142 164.595Z",
    fill: "#1C212F"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.0431 83.1427L96.4168 84.0878C96.0225 84.2301 95.5841 84.0225 95.4432 83.6284C95.3013 83.2333 95.5084 82.794 95.9026 82.6528L98.529 81.7077C98.9232 81.5654 99.3606 81.7719 99.5026 82.167C99.6434 82.5622 99.4374 83.0015 99.0431 83.1427Z",
    fill: "#0099FF"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.7892 84.7316L96.1629 85.6778C95.7686 85.819 95.3302 85.6124 95.1893 85.2173C95.0474 84.8222 95.2545 84.3828 95.6477 84.2417L98.2751 83.2965C98.6683 83.1543 99.1067 83.3619 99.2487 83.7559C99.3895 84.151 99.1835 84.5904 98.7892 84.7316Z",
    fill: "#0099FF"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.616 86.3985L95.9886 87.3436C95.5943 87.4858 95.157 87.2793 95.015 86.8842C94.8742 86.4891 95.0802 86.0497 95.4745 85.9085L98.1008 84.9634C98.4951 84.8212 98.9335 85.0287 99.0744 85.4228C99.2163 85.8179 99.0092 86.2573 98.616 86.3985Z",
    fill: "#0099FF"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.2991 88.1148L95.6727 89.06C95.2785 89.2022 94.8401 88.9946 94.6992 88.6006C94.5572 88.2054 94.7633 87.7661 95.1576 87.6249L97.785 86.6798C98.1782 86.5375 98.6166 86.744 98.7585 87.1392C98.8994 87.5343 98.6933 87.9736 98.2991 88.1148Z",
    fill: "#0099FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSomethingWentWrong);
export default __webpack_public_path__ + "static/media/Something_went_wrong.d11e67a18b66f8022fa0dc57fa525a3c.svg";
export { ForwardRef as ReactComponent };